<template>
    <div>
        <div class="chat-content">
            <div v-for="message in thread" :key="JSON.stringify(message)" :class="{ 'chat-message': true, 'incoming': message.direction == 'incoming', 'outgoing': message.direction == 'outgoing' }">
                {{ message.content }}
                <span class="chat-meta">
                    {{ message.direction == 'outgoing' ? 'You' : message.sender.name }} on Day {{ message.gameDay }} ({{ message.sent | utcAsLocal | moment("hh:mm a") }})
                </span>
            </div>
        </div>

        <div class="chat-footer">
            <v-container>
                <v-card outlined>
                    <v-card-text class="pb-0">
                        <v-text-field v-model="message" single-line dense append-outer-icon="mdi-send" label="Message" type="text" @click:append-outer="sendMessage()" @keyup.enter="sendMessage()" :hint="messageHint" persistent-hint></v-text-field>
                    </v-card-text>
                </v-card>
            </v-container>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    data: () => ({
        message: ""
    }),
    computed: {
        ...mapState({
            thread(state) {
                return state.textMessages[this.threadId];
            },
            players: state => state.players,
            threadInfo(state) {
                return state.threadInfo[this.threadId] || {};
            }
        }),
        threadId() {
            return this.$route.params.id;
        },
        messageHint() {
            if (this.threadInfo.spoofName) {
                return `Spoofing as ${this.threadInfo.spoofName } with role ${this.threadInfo.spoofRole }.`;
            } else {
                return null;
            }
        }
    },
    methods: {
        scrollToBottom() {
            this.$log.debug("Scrolling down!");
            window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
        },
        sendMessage() {
            if (this.message.trim().length <= 0) {
                return;
            }

            this.$socket.client.emit("send_message", {
                content: this.message,
                type: "text",
                recipient: this.threadInfo.withId,
                thread: this.threadId,
                spoofName: this.threadInfo.spoofName || "",
                spoofRole: this.threadInfo.spoofRole || ""
            });

            this.message = "";
        }
    },
    watch: {
        thread() {
            setTimeout(this.scrollToBottom, 250);
        }
    },
    mounted() {
        this.scrollToBottom();
    }
}
</script>

<style scoped>
    .chat-content {
        margin-bottom: 100px;
        display: flex;
        flex-flow: column nowrap;
    }

    .chat-message {
        margin: 10px;
        padding: 10px;
    }

    .chat-message.incoming {
        border-radius: 15px 15px 15px 3px;
        background-color: #E0E0E0;
        color: black;
        align-self: flex-start;
    }

    .chat-message.outgoing {
        border-radius: 15px 15px 3px 15px;
        background-color: #D500F9;
        color: white;
        align-self: flex-end;
    }

    .chat-footer {
        position: fixed;
        bottom: 10px;
        left: 0;
        right: 0;
    }

    .chat-meta {
        display: block;
        font-size: 0.8em;
        opacity: 0.7;
    }
</style>
